<template>
<v-app>
  <contact-form
    :name="name"
    :authentication-token="authenticationToken"
    :required-fields="requiredFields">
      <newsletter-fields :exclude="exclude"></newsletter-fields>
  </contact-form>
</v-app>
</template>

<script>
import ContactForm from "./ContactForm";
import NewsletterFields from "./NewsletterFields";

export default {
  name: "ContactFormApp",

  components: {
    ContactForm,
    NewsletterFields
  },

  data() {
    return {
      name: "newsletter"
    }
  },

  computed: {
    requiredFields() {
      return this.$yeti.formRequiredFields(this.name);
    },

    authenticationToken() {
      if (this.$store && this.$store.state) {
        return this.$store.state.auth.authenticationToken;
      }

      return null;
    },

    loggedIn() {
      if (this.$store && this.$store.state) {
        return this.$store.state.user.loggedIn;
      }

      return false;
    },

    exclude() {
      let ignoreFields = [];
      if (this.loggedIn) {
        ignoreFields = ["email"];
      }

      let el = [];
      if (this.$root.exclude) {
        el = this.root.exclude;
      }

      return ignoreFields.concat(el);
    }
  }
};
</script>
